import React from 'react';
import { Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { ADMIN_HEADER_HEIGHT, HEADER_HEIGHT, MOBILE_NAV_ROW_HEIGHT } from './AdminHeaderBar.constants';

type AdminHeaderBarSpacerProps = Readonly<{
  /**
   * Set to `true` when the corresponding AdminHeaderBar has a `navigation`
   * prop with mobile tabs visible. This accounts for the extra row height
   * on mobile.
   *
   * @example
   * <AdminHeaderBar title="Website" navigation={<WebsiteTabNav />} />
   * <AdminHeaderBar.Spacer navigation />
   */
  navigation?: boolean;
}>;

/**
 * Spacer component for fixed AdminHeaderBar positioning.
 *
 * @example
 * <AdminHeaderBar title="Website" navigation={<WebsiteTabNav />} />
 * <AdminHeaderBar.Spacer navigation />
 *
 * @example
 * <AdminHeaderBar title="Settings" />
 * <AdminHeaderBar.Spacer />
 */
export const AdminHeaderBarSpacer: React.FC<AdminHeaderBarSpacerProps> = ({ navigation = false }) => (
  <Box
    // With mobile tabs the header wraps them onto a second row below `md`, so reserve both rows there.
    height={navigation ? { _: pxToRem(ADMIN_HEADER_HEIGHT + MOBILE_NAV_ROW_HEIGHT), md: HEADER_HEIGHT } : HEADER_HEIGHT}
    flexShrink={0}
    aria-hidden="true"
    data-testid="admin-header-bar-spacer"
  />
);

AdminHeaderBarSpacer.displayName = 'AdminHeaderBarSpacer';
